import { render, staticRenderFns } from "./MProductDetails.vue?vue&type=template&id=01cd95ef&scoped=true"
import script from "./MProductDetails.vue?vue&type=script&lang=js"
export * from "./MProductDetails.vue?vue&type=script&lang=js"
import style0 from "./MProductDetails.vue?vue&type=style&index=0&id=01cd95ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd95ef",
  null
  
)

export default component.exports